import "pixi-spine";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IServerController} from "@nolimitcity/slot-game/bin/core/server/ServerController";
import {WarriorGraveyardServerController} from "./server/data/WarriorGraveyardServerController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {WGGameConfig} from "./WGGameConfig";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {WarriorWinFieldController} from "./presentations/features/win/initialwin/WarriorWinFieldController";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class WarriorGraveyard extends SlotGame {

    protected initServer(): IServerController {
        return new WarriorGraveyardServerController();
    }
    protected createWinFieldController(): WinFieldController {
        return new WarriorWinFieldController();
    }
    public getReadyToStart(): Promise<NolimitPlugin> {
        WGGameConfig.LANGUAGE_OTHER_THAN_EN = (SlotGame.api.options.language !== "en");
        return super.getReadyToStart();
    }

    public async getReady(): Promise<NolimitPlugin> {

        return super.getReady().then((value: NolimitPlugin) => {

        if(WarriorGraveyard.api.gameClientConfiguration.showMultipliersInfo) {
            this.addPayTableReplaceListener();
            this.loadAndReplaceAssets(value, "resources/images/");
        }
            return value;
        });
    }


    private addPayTableReplaceListener(){
        WarriorGraveyard.api.events.on("screen", (data:string)=> {
            if (data == "open") {
                const gameInfo = document.getElementById("gameInfoContainer");
                const bonus = gameInfo?.getElementsByClassName("noLimitBonus")[0];
                if(bonus) {
                    const elements = bonus.getElementsByClassName("buyFeatureImage")
                    for (let element of elements){
                        if ((<HTMLImageElement>element).alt==="FREESPIN_BETTER"){
                            (<HTMLImageElement>element).src = NolimitApplication.resourcePath + "/resources/images/" + (<HTMLImageElement>element).alt + ".png"
                        }
                    }
                }
            }
        });

    }

    private loadAndReplaceAssets(value:NolimitPlugin, path:string){
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("FREESPIN_BETTER_rep", path + "FREESPIN_BETTER.png");


        const replaceList = [
            "FREESPIN_BETTER_rep",
        ]
        const promises = Promise.all([ imgLoader.load()]);
        return promises.then((values: any) => {
            for (let replaceName of replaceList) {
                let baseTextureNew:PIXI.BaseTexture = PIXI.utils.BaseTextureCache[replaceName];
                const realName = replaceName.replace("_rep", "");
                if(PIXI.utils.TextureCache[realName]) {
                    const newTexture = PIXI.utils.TextureCache[replaceName];
                    const texture = PIXI.utils.TextureCache[realName];
                    texture.baseTexture = baseTextureNew;
                    texture.frame = newTexture.frame;
                    texture.trim = newTexture.trim;
                    texture.updateUvs();
                }
            }
            return value;
        });
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L1",
                    "L5",
                    "L3",
                    "L3",
                    "L3"
                ],
                [
                    "M4",
                    "M4",
                    "L1",
                    "L1",
                    "L1"
                ],
                [
                    "L3",
                    "L2",
                    "L2",
                    "L1",
                    "L4"
                ],
                [
                    "L3",
                    "L3",
                    "L3",
                    "L2",
                    "L2"
                ],
                [
                    "L5",
                    "L4",
                    "L4",
                    "L4",
                    "L2"
                ],
                [
                    "L4",
                    "L2",
                    "L4",
                    "L4",
                    "L4"
                ]
            ],
            "evaluatedArea": [
                [
                    "L5",
                    "L3",
                    "L3"
                ],
                [
                    "M4",
                    "L1",
                    "L1"
                ],
                [
                    "L2",
                    "L2",
                    "L1"
                ],
                [
                    "L3",
                    "L3",
                    "L2"
                ],
                [
                    "L4",
                    "L4",
                    "L4"
                ],
                [
                    "L2",
                    "L4",
                    "L4"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "overlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "doScatterNudge": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "M4",
                    "L3"
                ],
                [
                    "L4",
                    "M4"
                ],
                [
                    "L1",
                    "L2"
                ],
                [
                    "L3",
                    "L3"
                ],
                [
                    "L2",
                    "L4"
                ],
                [
                    "L2",
                    "L5"
                ]
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "multiplierBeforeSpin": 1,
            "wildMultipliers": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 72
                },
                {
                    "name": "FREESPIN_BETTER",
                    "type": "FREESPIN",
                    "price": 666
                }
            ],
            "featureBet": false,
            "wasFeatureBuy": false,
            "activeWarriorSymbolReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "triggerWarriorPay": false,
            "triggerWarriorSymbol": "",
            "warriorMultiplier": 0,
            "warriorTimesBetPay": 0,
            "warriorPayout": 0,
            "superFreespin": false,
            "lockedFSWildMultiplier": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "lockedWildReelsBefore": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "lockedWildReelsAfter": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinWarrior": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "warriorBetLineWins": [],
            "warriorMultipliers": [
                0,
                0,
                0,
                0,
                0,
                0
            ]
        };
    }
}